import Icon from '../../../components/AppIcon';
import type { SocialLink } from '../types';

interface SocialLinksProps {
  links: SocialLink[];
}

const SocialLinks = ({ links }: SocialLinksProps) => {
  return (
    <div className="flex flex-wrap gap-4 justify-center">
      {links.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 rounded-lg bg-surface hover:bg-gradient-accent flex items-center justify-center transition-all duration-300 hover:scale-110 border border-border hover:border-accent group"
          aria-label={link.label}
        >
          <Icon
            name={link.icon}
            size={20}
            color="var(--color-text-primary)"
            className="group-hover:scale-110 transition-transform duration-300"
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;